/** @typedef {import('@basqet-dashboard/common/types/api').ApiResponse} ApiResponse */

import { instance } from '@basqet-dashboard/common/config/api';

/**
 * @param {string} currency
 * @returns {Promise<ApiResponse<object>>}
 */
const getStaticVirtualAccount = async (currency) => {
  const { data } = await instance.get(`virtual-accounts/static/${currency}`, {
    suppressErrorLog: true
  });
  return data;
};

/**
 * @param {{ currency: string }} body
 * @returns {Promise<ApiResponse<object>>}
 */
const createStaticVirtualAccount = async (body) => {
  const { data } = await instance.post('virtual-accounts/static', body);
  return data;
};

export { createStaticVirtualAccount, getStaticVirtualAccount };
